export const WORKPLACE_PROD_URL = 'https://workplace.meetingdoctors.com'
export const WORKPLACE_DEV_URL = 'https://workplace.dev.meetingdoctors.com'
export const MAIL_TO = 'mailto:soporte@meetingdoctors.com'
